import styled from 'styled-components';
import { Button } from '@salutejs/sdds-insol';
import { useModalStore } from '@/entities/Modal';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';

const StyledButton = styled(Button)`
    background-color: #333f48;
`;

type Props = {
    className?: string;
};

export const DepositButton = ({ className }: Props) => {
    const { setIsDepositModalOpen } = useModalStore();

    const width = useResize();
    const buttonSize = width >= 768 ? 'xl' : 'm';

    return (
        <StyledButton
            className={className}
            view="dark"
            type="button"
            size={buttonSize}
            stretch
            onClick={() => {
                setIsDepositModalOpen(true);
            }}
        >
            <span className="SBSansText">Пополнить</span>
        </StyledButton>
    );
};
